const ROUTE_PATHS = {
  preload: '/wallet-transfer/:token',
  authentication: '/wallet-transfer/auth/:token',
  errorNumber: '/wallet-transfer/number-error/:token',
  expired: '/wallet-transfer/expired/:token',
  success: '/wallet-transfer/success/:token',
  error: '/wallet-transfer/invalid/request',
};

export default ROUTE_PATHS;
